<table>
  <thead>
  <tr>
    <th *ngFor="let header of headers" (click)="sort(header)">
      {{ header.title }}
      <span *ngIf="!header.edit && header.sortable !== false">
          <ng-container *ngIf="currentSort == '' || currentSortHeader != header.key">
            <app-icon [icon]="Icons.sortNone"/>
          </ng-container>
          <ng-container *ngIf="currentSort == 'asc' && currentSortHeader == header.key">
             <app-icon [icon]="Icons.sortUp"/>
          </ng-container>
          <ng-container *ngIf="currentSort == 'desc' && currentSortHeader == header.key">
             <app-icon [icon]="Icons.sortDown"/>
          </ng-container>
        </span>
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let row of data" (click)="openItemRow(row)">
    <td *ngFor="let header of headers" [style.width]="header.width || 'auto'">
      <div *ngIf="header.img" class="image-text-container">
        <img *ngIf="row?.image" [src]="environment.s3Prefix + row.image" [alt]="row.image" loading="lazy" width="100" height="auto">
        <span class="content-cell">
          {{
            header.date && !!getPropValue(row, header.key) ?
              dateFormatYYYYMMDDTODDMMYYYY(getPropValue(row, header.key)) + (header.addKey ? (' ' + getPropValue(row, header.addKey)).substring(0, 6) : '')
              : getPropValue(row, header.key)
          }}
        </span>
      </div>
      <span *ngIf="!header.img && !header.edit" class="content-cell">
        {{
          header.date && !!getPropValue(row, header.key) ?
            dateFormatYYYYMMDDTODDMMYYYY(getPropValue(row, header.key)) + (header.addKey ? (' ' + getPropValue(row, header.addKey)).substring(0, 6) : '')
            : getPropValue(row, header.key)
        }}
      </span>
      <div *ngIf="header.edit" class="icon-open-item">
        <app-icon [icon]="Icons.squareArrow" (click)="openItem($event, row)"/>
      </div>
    </td>
  </tr>
  </tbody>
</table>
